import { ModalWindow, UIHeading2, UIText1, LinkButton } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './BrokerRedirectModal.css';
import Success24Icon from './icons/success24.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BrokerRedirectModal = function BrokerRedirectModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    brokerUrl = _ref.brokerUrl;
  return /*#__PURE__*/_jsx(ModalWindow, {
    content: /*#__PURE__*/_jsxs("div", {
      className: styles['content'],
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['icon'],
        children: /*#__PURE__*/_jsx("img", {
          src: Success24Icon
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles['heading'],
        children: /*#__PURE__*/_jsx(UIHeading2, {
          children: "\u0412\u0441\u0451 \u0433\u043E\u0442\u043E\u0432\u043E"
        })
      }), /*#__PURE__*/_jsx(UIText1, {
        children: "\u041F\u0440\u043E\u0441\u0442\u043E \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043F\u0435\u0440\u0435\u0445\u043E\u0434 \u043D\u0430 \u0441\u0430\u0439\u0442 \u043F\u0430\u0440\u0442\u043D\u0451\u0440\u0430"
      })]
    }),
    footer: /*#__PURE__*/_jsx("div", {
      className: styles['footer'],
      children: /*#__PURE__*/_jsx(LinkButton, {
        href: brokerUrl,
        size: "XS",
        onClick: onClose,
        target: "_blank",
        rel: "noopener noreferrer",
        children: "\u0414\u0430\u0432\u0430\u0439\u0442\u0435 \u0441\u043A\u043E\u0440\u0435\u0435"
      })
    }),
    escape: true,
    fixed: false,
    onClose: onClose,
    open: isOpen,
    outside: true,
    print: true,
    size: "M",
    width: 648
  });
};